
import React from 'react';

const FooterContact = () => {
  return (
    <div>
      <h3 className="font-bold mb-4 text-lg">Contact</h3>
      <ul className="space-y-2">
        <li className="text-gray-300">support@nationcard.org</li>
        <li className="text-gray-300">Media: press@nationcard.org</li>
        <li className="text-gray-300">Partnerships: partners@nationcard.org</li>
      </ul>
    </div>
  );
};

export default FooterContact;
